import { replace, map, attempt, isError } from 'lodash';
/**
 * Replace path params to create a route
 *
 * @param {string} route
 * @param {object} params
 * @returns {string}
 */
export function buildRoute(route, params) {
    return replace(route, /\{([\w-]+)\}/g, function (fullMatch, key) {
        var value;
        if (params.hasOwnProperty(key)) {
            value = params[key];
        }
        else {
            value = key;
        }
        return encodeURIComponent(value);
    });
}
/**
 * Create the query path
 *
 * @param {object} queries the value of the object as strings
 * @returns {string} query encoded ex: foo=1&bar=2&bar=3
 */
export function encodeQueryData(queries) {
    return map(queries, function (v, k) {
        if (Array.isArray(v)) {
            return map(v, function (vv) { return encodeURIComponent(k) + '=' + encodeURIComponent(vv); })
                .join('&');
        }
        return encodeURIComponent(k) + '=' + encodeURIComponent(v);
    })
        .join('&');
}
/**
 * Parse JSON with Lodash
 * _.attempt prevents JSON.parse from throwing an application error.
 * Instead, it would return an Error object.
 *
 * @param {string} str JSON string
 * @returns {Promise} resolve to JSON object
 */
export function parseJSON(str) {
    if (str === '') {
        return {};
    }
    var output = attempt(JSON.parse.bind(null, str));
    if (isError(output)) {
        var error = {
            errorCode: 'INVALID_JSON',
            message: output
        };
        throw error;
    }
    return output;
}
export function isGatewayResponse(obj) {
    return obj.code !== undefined && obj.correlationId !== undefined && obj.data !== undefined;
}
//# sourceMappingURL=utils.js.map